import React, { useState } from 'react';
import '../Potemplate.css';

export function TextInput({
  name,
  placeHolder,
  label,
  requiredField,
  charCount,
  maxCount,
  onlyRead,
  fromForm,
  duplicatingItem,
  editingInput,
  index,
  i,
  id,
  eleIndex,
  elekey,
  value,
  onChange,
  disable,
  showDelete,
  deleteItem,
  elementId,
  fromCustomSection,
}) {
  const [isOver, setIsOver] = useState(false);

  const mouseOver = () => {
    setIsOver(true);
  };
  const mouseOut = () => {
    setIsOver(false);
  };

  const handleDuplicateItem = () => {
    fromCustomSection ? duplicatingItem(index, i, elementId, fromCustomSection) : duplicatingItem(index, i, elekey);
    setIsOver(false);
  };

  return (
    <div className="input-group form-floating-label-po fixed-label" onMouseEnter={mouseOver} onMouseLeave={mouseOut}>
      <label className={`asterisk-req ${fromForm && 'd-flex'}`}>
        {label}
        {requiredField && <span>*</span>}
      </label>
      <input
        key={`_${eleIndex}_${i}_${index}`}
        type="text"
        name={name}
        placeholder={placeHolder}
        className="form-control"
        disabled={disable}
        readOnly={onlyRead}
        value={value}
        autoComplete="off"
        onChange={(e) => onChange(e.target.value, label, i, eleIndex, index)}
      />
      {fromForm && isOver && (
        <div className="potemp-action-btns">
          <button
            type="button"
            className="btn btn-border ml-auto py-0 px-1"
            key={`_${eleIndex}_${i}_${index}`}
            onClick={() => editingInput(index, i, eleIndex)}
          >
            <span className="icon-edit" />
          </button>
          {showDelete && isOver && (
            <button
              type="button"
              className="btn btn-border py-0 px-1"
              key={`_${eleIndex}_${i}_${index}`}
              onClick={() => deleteItem(index, i, elekey, eleIndex)}
            >
              <span className="icon-delete" />
            </button>
          )}
          <button type="button" className="btn btn-border py-0 px-1" key={`_${eleIndex}_${i}_${index}`} onClick={() => handleDuplicateItem()}>
            <span className="icon-copy" />
          </button>
        </div>
      )}
      {charCount && (
        <div className="text-count" key={`_${eleIndex}_${i}_${index}`}>
          0/{maxCount}
        </div>
      )}
    </div>
  );
}
export default TextInput;
